<template>
  <div class="new_post">
    <form
        class="forms-sample"
        :key="$route.params.FAQ"
        style="border-radius: 10px; border: 1px solid gainsboro;"
    >
      <h6 class="sub-title color-default font-weight-bold mb-3">{{ formHeader }}</h6>

      <div class="form-group row">
        <div class="col-md-6">
          <label for="title" class="label-form">Question<span style="color: red">*</span>:</label>
          <input
              type="text"
              id="title"
              class="form-control"
              v-model="postForm.title"
              placeholder="Question"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6">
          <label for="orderNumber" class="label-form">Order Number<span style="color: red">*</span>:</label>
          <input
              type="text"
              id="orderNumber"
              class="form-control"
              v-model="postForm.order_number"
              placeholder="Order Number"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form">Category<span style="color: red">*</span>:</label>
          <multiselect
              v-model="postForm.FAQcategory"
              :options="FAQcategories"
              label="title"
              track-by="id"
              placeholder="Select category of the FAQ"
              :allow-empty="false"
              :searchable="true"
              :selectLabel="null"
              :deselectLabel="null"
          ></multiselect>
        </div>
      </div>

      <div class="form-group">
        <label for="describtion" class="label-form">Answer<span style="color: red">*</span>:</label>
        <div class="text_editor">
          <tiny-mce-editor :vModelName.sync="postForm.body"></tiny-mce-editor>
        </div>
      </div>

      <div class="form-group">
        <label for="describtion" class="label-form">Video:</label>
        <div class="text_editor">
          <tiny-mce-editor
                  :vModelName.sync="postForm.video"
                  :media="false"
                  :idEditor="1"
              >
              </tiny-mce-editor>
        </div>
      </div>

      <div class="text-right">
        <button
            class="btn"
            :class="formbtn === 'add' ? 'btn btn-default text-light ml-3 px-3 py-2' : 'btn btn-success text-light ml-3 px-3 py-2'"
            @click.prevent="save"
            :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading"
        >
          <font-awesome-icon
              v-if="isMiniLoading"
              icon="spinner"
              style="animation: spin 2s linear infinite"
          />
          {{ formbtn === 'add' ? 'Save' : 'Update' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import "jodit/build/jodit.min.css";
import TinymceEditor from "../../views/partials/tiny_mce_editor";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    "tiny-mce-editor": TinymceEditor,
  },
  data() {
    return {
      formHeader: "",
      isMiniLoading: false,
      isLoading: false,
      isLoadingCategory: false,
      formbtn: "add",
      postForm: {
        title: "",
        body: "",
        video: "",
        FAQcategory: "",
        order_number: "",
        remove_image: false,
      },
    };
  },
  computed: {
    FAQ() {
      return this.$store.getters["faqs/FAQ"];
    },
    FAQcategories() {
      return this.$store.getters["faqcategories/allCategories"];
    },
  },
  created() {
    this.initializeForm();
    this.$store.dispatch('faqcategories/getAllCategories');
  },
  methods: {
    initializeForm() {
      if (this.$route.params.FAQ) {
        this.formHeader = "Update FAQs";
        this.loadFAQ();
      } else {
        this.formHeader = "New FAQs";
        this.isLoading = false;
      }
    },
    loadFAQ() {
      this.$store
          .dispatch("faqs/getFAQ", this.$route.params.FAQ)
          .then(() => {
            const FAQ = this.$store.getters["faqs/FAQ"];
            let body = FAQ.body.replace(/faqs\/images\/.*?\.png/g, (imagePath) => {
              return this.$baseURL + "/storage/" + imagePath;
            });

            if (body.substr(0, 26) === '<div class="body-wrapper">') {
              body = body.substring(26, body.lastIndexOf("</div>"));
            }


            let video = FAQ.video.replace(/faqs\/images\/.*?\.png/g, (imagePath) => {
              return this.$baseURL + "/storage/" + imagePath;
            });
            if (video.substr(0, 26) === '<div class="body-wrapper">') {
              video = video.substring(26, video.lastIndexOf("</div>"));
            }

            this.postForm.slug = FAQ.slug;
            this.formbtn = "update";
            this.postForm = {
              ...this.postForm,
              title: FAQ.title,
              body: body,
              video: video,
              FAQcategory: FAQ.FAQCategory,
              order_number: FAQ.order_number,
            };
            this.isLoading = false;
            this.$store.commit("faqcategories/SET_CATEGORIES_SEARCH", [FAQ.FAQCategory]);
          })
          .catch(() => {
            this.$toast.info(`Can't find FAQ '${this.$route.params.FAQ}'!`);
            this.$router.push("/faqs/new-post");
          });
    },

    save() {
      if (!this.validateForm()) {
        this.isMiniLoading = false;
        return;
      }

      this.isMiniLoading = true;
      if (this.formbtn === "add") {
        this.createFAQ();
      } else {
        this.updateFAQ();
      }
    },
    validateForm() {
      if (!this.postForm.title) {
        this.$toast.error("Question field is required!");
        return false;
      }

      if (!this.postForm.order_number) {
        this.$toast.error("Order number is required!");
        return false;
      }

      if (this.postForm.title){
        if (this.containsOnlyNumbers(this.postForm.title.trim())){
          this.$toast.error("Please enter a valid Question!");
          return false;
        }
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(this.postForm.body, "text/html");
      const bodyContent = doc.body.textContent.trim();

      if (!bodyContent) {
        this.$toast.error(`Answer field is required.`);
        return false;
      }

      if (!this.postForm.FAQcategory) {
        this.$toast.error("Please select a category!");
        return false;
      }
      return true;
    },
    createFAQ() {
      this.$store
          .dispatch("faqs/createFAQ", this.postForm)
          .then(() => {
            this.$toast.success(`${this.postForm.title} FAQ has been added successfully`);
            this.$router.push("/faqs");
          })
          .catch(this.handleError);
    },
    updateFAQ() {
      this.$store
          .dispatch("faqs/updateFAQ", this.postForm)
          .then(() => {
            this.$toast.success(`${this.postForm.title} FAQ has been updated successfully`);
            this.$router.push("/faqs");
          })
          .catch(this.handleError);
    },
    handleError(error) {
      if (error.response.data.errors) {
        Object.keys(error.response.data.errors).forEach((key) => {
          error.response.data.errors[key].forEach((errorMsg) => {
            this.$toast.error(errorMsg);
          });
        });
      }
      this.isMiniLoading = false;
    },

    containsOnlyNumbers(input) {
      return !isNaN(input);
    }
  },
};
</script>

<style scoped>
.new_post {
  margin-top: -75px !important;
}
</style>
